// extracted by mini-css-extract-plugin
module.exports = {"greyDark1":"#55565a","copyField":"TextLink__copyField","link":"TextLink__link"};